import { Link } from "react-router-dom";
import { Crown } from "lucide-react";

/**
 * Top of the Lot brand mark.
 * - `compact` = square icon only (for headers / mobile).
 * - default full lockup (icon + wordmark) for landing/auth pages.
 */
export default function BrandMark({ compact = false, className = "", asLink = true }) {
  const icon = (
    <div className="w-9 h-9 rounded-xl bg-[#C7F500] flex items-center justify-center relative shadow-[0_0_0_1px_rgba(255,255,255,0.06),0_6px_18px_rgba(199,245,0,0.22)]">
      <Crown className="w-4 h-4 text-[#071426]" strokeWidth={2.4} />
      <div className="absolute -bottom-1 -right-1 text-[9px] font-heading font-black text-[#F5B942] bg-[#071426] rounded-md px-1 leading-none py-0.5 border border-[#132A45]">TL</div>
    </div>
  );
  const inner = (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-mark">
      {icon}
      {!compact && (
        <div className="flex flex-col leading-none">
          <span className="font-heading text-lg tracking-wider text-white">TOP OF THE LOT</span>
          <span className="text-[10px] uppercase tracking-[0.25em] text-[#AAB7C7] mt-0.5">Football Predictor</span>
        </div>
      )}
    </div>
  );
  if (!asLink) return inner;
  return <Link to="/">{inner}</Link>;
}
